export default "__VITE_ASSET__BRwDm33Y__"